<template>
  <div class="AppBulkListItem d-flex align-center column-gap-2 text--bold">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppBulkListItem',
})
</script>

<style scoped lang="scss">
.AppBulkListItem {
  background-color: rgb(var(--v-theme-grey-25));
  border-radius: 8px;
  border: 1px solid rgb(var(--v-theme-grey-50));
  min-height: 52px;
  padding: 8px 16px;
}
</style>